import shared from "emun.auth/auth.config.es6"; //get shared
export const IS_OFFLINE = (ENV_TAGS || []).indexOf("Offline") >= 0; //webpack.DefinePlugin
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0;

export default Object.assign(shared, {
  hideForgotPassword: IS_CMS ? false : true,
  hideCorporateType: false,
  loginModes: IS_OFFLINE ? ["Local", "Regional"] : [], //IS_OFFLINE
});
